import React from 'react';
import PropTypes from 'prop-types';
import { contains, property } from 'underscore';
import { linkLocalizer } from 'locale-helper';
import CopySection from './components/copy_section';

const CopySectionsView = ({ copySections, heading }) => {
  if (!(copySections && copySections.length)) return null;

  const IsMainSection = () => {
    const urls = [...window.VCSTATE.SITE_NAV_SECTIONS.map(property('url')), '/lottery', '/'];
    const urlsWithLocale = urls.map((loc) => linkLocalizer(loc));
    return contains(urlsWithLocale, window.location.pathname);
  };

  return (
    <div className="site-copy-wrapper site-copy">

      {heading && IsMainSection() && (
        <h1 className="site-copy-heading bvs-h4">
          {heading}
        </h1>
      )}

      {copySections.map((section) => (
        <CopySection
          key={section.title}
          title={section.title}
          content={section.content}
        />
      ))}
    </div>
  );
};

CopySectionsView.propTypes = {
  copySections: PropTypes.instanceOf(Array).isRequired,
  heading: PropTypes.string,
};

CopySectionsView.defaultProps = {
  heading: null,
};

export default CopySectionsView;
